<div class="backdrop" *ngIf="backdropImage">
    <div class="backdrop__image" [style.background-image]="'url(' + backdropImage + ')'"></div>
</div>

<div class="content">
    <ng-content></ng-content>
</div>
